<template>
	<div class="aboutus-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ type === 'info' ? '内容详情' : (id ? '编辑内容' : '新增内容') }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">关于我们管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ type === 'info' ? '查看详情' : (id ? '编辑内容' : '新增内容') }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : '保存' }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="120px"
				class="aboutus-form"
			>
				<!-- 基本信息 -->
				<div class="form-section">
					<h3 class="section-title">基本信息</h3>
					
					<!-- 标题 -->
					<el-form-item label="标题" prop="title" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.title }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M5,4V7H10.5V19H13.5V7H19V4H5Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.title" 
									placeholder="请输入标题" 
									:readonly="type === 'info' || ro.title"
									clearable
									class="form-input"
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.title">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">请输入企业或页面的主标题</span>
						</div>
					</el-form-item>

					<!-- 副标题 -->
					<el-form-item label="副标题" prop="subtitle" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.subtitle }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M5,9H19L18,8H6L5,9M3,5H21L20,4H4L3,5M7,13H17L16.5,12H7.5L7,13Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.subtitle" 
									placeholder="请输入副标题" 
									:readonly="type === 'info' || ro.subtitle"
									clearable
									class="form-input"
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.subtitle">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">可选，用于补充主标题信息</span>
						</div>
					</el-form-item>
				</div>

				<!-- 图片设置 -->
				<div class="form-section">
					<h3 class="section-title">图片设置</h3>
					
					<!-- 图片1 -->
					<el-form-item v-if="type !== 'info' && !ro.picture1" label="图片1" prop="picture1" class="form-item image-item">
						<div class="image-upload-wrapper">
							<file-upload
								tip="点击上传图片1"
								action="file/upload"
								:limit="3"
								:multiple="true"
								:fileUrls="ruleForm.picture1?ruleForm.picture1:''"
								@change="picture1UploadChange"
								class="image-uploader"
							></file-upload>
							<div class="upload-tips">
								<h4>图片1上传说明：</h4>
								<ul>
									<li>支持格式：JPG、PNG、GIF</li>
									<li>图片大小：不超过5MB</li>
									<li>建议尺寸：1200×800像素</li>
									<li>用于主要展示内容</li>
								</ul>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-else-if="ruleForm.picture1" label="图片1" prop="picture1" class="form-item image-item">
						<div class="image-preview">
							<template v-if="ruleForm.picture1.substring(0,4)==='http'">
								<img class="preview-img" :src="ruleForm.picture1.split(',')[0]" />
							</template>
							<template v-else>
								<img 
									v-for="(item,index) in ruleForm.picture1.split(',')" 
									v-bind:key="index" 
									class="preview-img" 
									:src="$base.url+item" 
								/>
							</template>
						</div>
					</el-form-item>

					<!-- 图片2 -->
					<el-form-item v-if="type !== 'info' && !ro.picture2" label="图片2" prop="picture2" class="form-item image-item">
						<div class="image-upload-wrapper">
							<file-upload
								tip="点击上传图片2"
								action="file/upload"
								:limit="3"
								:multiple="true"
								:fileUrls="ruleForm.picture2?ruleForm.picture2:''"
								@change="picture2UploadChange"
								class="image-uploader"
							></file-upload>
							<div class="upload-tips">
								<h4>图片2上传说明：</h4>
								<ul>
									<li>可选图片，用于辅助展示</li>
									<li>建议与图片1形成对比或补充</li>
									<li>同样支持多种格式</li>
								</ul>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-else-if="ruleForm.picture2" label="图片2" prop="picture2" class="form-item image-item">
						<div class="image-preview">
							<template v-if="ruleForm.picture2.substring(0,4)==='http'">
								<img class="preview-img" :src="ruleForm.picture2.split(',')[0]" />
							</template>
							<template v-else>
								<img 
									v-for="(item,index) in ruleForm.picture2.split(',')" 
									v-bind:key="index" 
									class="preview-img" 
									:src="$base.url+item" 
								/>
							</template>
						</div>
					</el-form-item>

					<!-- 图片3 -->
					<el-form-item v-if="type !== 'info' && !ro.picture3" label="图片3" prop="picture3" class="form-item image-item">
						<div class="image-upload-wrapper">
							<file-upload
								tip="点击上传图片3"
								action="file/upload"
								:limit="3"
								:multiple="true"
								:fileUrls="ruleForm.picture3?ruleForm.picture3:''"
								@change="picture3UploadChange"
								class="image-uploader"
							></file-upload>
							<div class="upload-tips">
								<h4>图片3上传说明：</h4>
								<ul>
									<li>第三张可选图片</li>
									<li>用于全面展示企业形象</li>
									<li>建议选择有代表性的照片</li>
								</ul>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-else-if="ruleForm.picture3" label="图片3" prop="picture3" class="form-item image-item">
						<div class="image-preview">
							<template v-if="ruleForm.picture3.substring(0,4)==='http'">
								<img class="preview-img" :src="ruleForm.picture3.split(',')[0]" />
							</template>
							<template v-else>
								<img 
									v-for="(item,index) in ruleForm.picture3.split(',')" 
									v-bind:key="index" 
									class="preview-img" 
									:src="$base.url+item" 
								/>
							</template>
						</div>
					</el-form-item>
				</div>

				<!-- 内容编辑 -->
				<div class="form-section">
					<h3 class="section-title">详细内容</h3>
					
					<el-form-item v-if="type !== 'info'" label="内容" prop="content" class="form-item editor-item">
						<div class="editor-wrapper">
							<editor 
								v-model="ruleForm.content" 
								class="content-editor" 
								action="file/upload"
							></editor>
						</div>
					</el-form-item>
					<el-form-item v-else-if="ruleForm.content" label="内容" prop="content" class="form-item content-item">
						<div class="content-display" v-html="ruleForm.content"></div>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			submitLoading: false, // 提交加载状态
			
			ro:{
				title : false,
				subtitle : false,
				content : false,
				picture1 : false,
				picture2 : false,
				picture3 : false,
			},
			
			
			ruleForm: {
				title: '',
				subtitle: '',
				content: '',
				picture1: '',
				picture2: '',
				picture3: '',
			},
		
			
			rules: {
				title: [
					{ required: true, message: '标题不能为空', trigger: 'blur' },
				],
				subtitle: [
				],
				content: [
					{ required: true, message: '内容不能为空', trigger: 'blur' },
				],
				picture1: [
				],
				picture2: [
				],
				picture3: [
				],
			}
		};
	},
	props: ["parent"],
	computed: {



	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='title'){
							this.ruleForm.title = obj[o];
							this.ro.title = true;
							continue;
						}
						if(o=='subtitle'){
							this.ruleForm.subtitle = obj[o];
							this.ro.subtitle = true;
							continue;
						}
						if(o=='content'){
							this.ruleForm.content = obj[o];
							this.ro.content = true;
							continue;
						}
						if(o=='picture1'){
							this.ruleForm.picture1 = obj[o];
							this.ro.picture1 = true;
							continue;
						}
						if(o=='picture2'){
							this.ruleForm.picture2 = obj[o];
							this.ro.picture2 = true;
							continue;
						}
						if(o=='picture3'){
							this.ruleForm.picture3 = obj[o];
							this.ro.picture3 = true;
							continue;
						}
				}
				






			}
			
			
			
			
		},
    // 多级联动参数

    info(id) {
      this.$http({
        url: `aboutus/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        //解决前台上传图片后台不显示的问题
        let reg=new RegExp('../../../upload','g')//g代表全部
        				this.ruleForm.content = this.ruleForm.content.replace(reg,'http://ht.yiminkangjian.top/taoziyiyuan/upload');
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {








	if(this.ruleForm.picture1!=null) {
		this.ruleForm.picture1 = this.ruleForm.picture1.replace(new RegExp(this.$base.url,"g"),"");
	}


	if(this.ruleForm.picture2!=null) {
		this.ruleForm.picture2 = this.ruleForm.picture2.replace(new RegExp(this.$base.url,"g"),"");
	}


	if(this.ruleForm.picture3!=null) {
		this.ruleForm.picture3 = this.ruleForm.picture3.replace(new RegExp(this.$base.url,"g"),"");
	}

var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.submitLoading = true;

       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "aboutus/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
					     this.submitLoading = false;
					       return false;
				       } else {
					 this.$http({
					   url: `aboutus/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   this.submitLoading = false;
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.aboutusCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				  this.submitLoading = false;
				} 
			});
		 } else {
			 this.$http({
			   url: `aboutus/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   this.submitLoading = false;
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.aboutusCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         } else {
           this.submitLoading = false;
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.aboutusCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    picture1UploadChange(fileUrls) {
	    this.ruleForm.picture1 = fileUrls;
    },
    picture2UploadChange(fileUrls) {
	    this.ruleForm.picture2 = fileUrls;
    },
    picture3UploadChange(fileUrls) {
	    this.ruleForm.picture3 = fileUrls;
    },
  }
};
</script>
<style lang="scss" scoped>
.aboutus-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 20px 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;
			flex: 1;

			.back-button {
				width: 40px;
				height: 40px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;
				color: #64748b;

				&:hover {
					background: #f1f5f9;
					border-color: #cbd5e1;
					color: #475569;
				}

				&:active {
					background: #e2e8f0;
				}

				i {
					font-size: 16px;
				}
			}

			.header-info {
				.page-title {
					font-size: 20px;
					font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
					line-height: 1.2;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 13px;
					color: #64748b;

					.breadcrumb-item {
						color: #64748b;
					}

					.breadcrumb-current {
						color: #7c3aed;
						font-weight: 500;
					}

					i {
						font-size: 12px;
						color: #94a3b8;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 6px;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 6px;

				i {
					font-size: 14px;
				}
			}

			.cancel-btn {
				color: #6b7280;
				border-color: #d1d5db;
				background: white;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
					background: #f9fafb;
				}
			}

			.submit-btn {
				background: #7c3aed;
				border-color: #7c3aed;
				color: white;

				&:hover {
					background: #6d28d9;
					border-color: #6d28d9;
				}

				&:disabled {
					background: #d1d5db;
					border-color: #d1d5db;
					color: #9ca3af;
				}
			}

			.back-btn {
				background: #6b7280;
				border-color: #6b7280;
				color: white;

				&:hover {
					background: #4b5563;
					border-color: #4b5563;
				}
			}
		}
	}
}

// 表单内容
.form-content {
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.aboutus-form {
		padding: 0;

		// 表单区块
		.form-section {
			padding: 24px;
			border-bottom: 1px solid #f1f5f9;

			&:last-child {
				border-bottom: none;
			}

			.section-title {
				font-size: 16px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 20px 0;
				padding-bottom: 12px;
				border-bottom: 2px solid #7c3aed;
				display: inline-block;
			}
		}

		// 表单项
		.form-item {
			margin-bottom: 24px;

			&:last-child {
				margin-bottom: 0;
			}

			:deep(.el-form-item__label) {
				font-weight: 600;
				color: #374151;
				font-size: 14px;
				line-height: 1.5;
				padding: 0 12px 0 0;
			}

			:deep(.el-form-item__content) {
				line-height: 1.5;
			}

			// 输入框包装器
			.input-wrapper {
				.input-field {
					position: relative;
					display: flex;
					align-items: center;
					background: white;
					border: 1px solid #d1d5db;
					border-radius: 6px;
					transition: all 0.2s ease;

					&:focus-within {
						border-color: #7c3aed;
						box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
					}

					&.readonly {
						background: #f8fafc;
						border-color: #e2e8f0;
					}

					.field-icon {
						width: 16px;
						height: 16px;
						margin: 0 12px;
						fill: #64748b;
						flex-shrink: 0;
					}

					.form-input {
						flex: 1;

						:deep(.el-input__inner) {
							border: none;
							padding: 12px 0;
							font-size: 14px;
							line-height: 1.5;
							color: #1e293b;
							background: transparent;

							&::placeholder {
								color: #9ca3af;
							}

							&:focus {
								box-shadow: none;
							}

							&[readonly] {
								background: transparent;
								color: #6b7280;
							}
						}
					}

					.readonly-indicator {
						margin-right: 12px;
						display: flex;
						align-items: center;
						
						.lock-icon {
							width: 14px;
							height: 14px;
							fill: #94a3b8;
						}
					}
				}

				.field-tip {
					display: block;
					margin-top: 6px;
					font-size: 12px;
					color: #6b7280;
					line-height: 1.4;
				}
			}

			// 图片相关
			&.image-item {
				.image-upload-wrapper {
					display: flex;
					gap: 24px;
					align-items: flex-start;

					.image-uploader {
						flex: 1;
					}

					.upload-tips {
						flex: 0 0 300px;
						background: #f8fafc;
						padding: 16px;
						border-radius: 6px;
						border: 1px solid #e2e8f0;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0 0 12px 0;
						}

						ul {
							margin: 0;
							padding: 0 0 0 16px;

							li {
								font-size: 12px;
								color: #6b7280;
								line-height: 1.6;
								margin-bottom: 4px;

								&:last-child {
									margin-bottom: 0;
								}
							}
						}
					}
				}

				.image-preview {
					display: flex;
					gap: 12px;
					flex-wrap: wrap;

					.preview-img {
						width: 120px;
						height: 120px;
						object-fit: cover;
						border-radius: 6px;
						border: 1px solid #e5e7eb;
					}
				}
			}

			// 编辑器相关
			&.editor-item {
				.editor-wrapper {
					border: 1px solid #d1d5db;
					border-radius: 6px;
					overflow: hidden;

					.content-editor {
						min-height: 400px;
					}
				}
			}

			// 内容显示
			&.content-item {
				.content-display {
					padding: 20px;
					background: #f8fafc;
					border: 1px solid #e2e8f0;
					border-radius: 6px;
					font-size: 14px;
					line-height: 1.6;
					color: #374151;
					min-height: 200px;
				}
			}
		}

		// 错误状态
		:deep(.el-form-item.is-error) {
			.input-field {
				border-color: #ef4444;

				&:focus-within {
					border-color: #ef4444;
					box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
				}
			}
		}

		// 必填标识
		:deep(.el-form-item.is-required) {
			.el-form-item__label::before {
				content: '*';
				color: #ef4444;
				margin-right: 4px;
			}
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.aboutus-form-container {
		padding: 20px;
	}

	.form-content {
		.aboutus-form {
			.form-section {
				padding: 20px;
			}

			.form-item {
				&.image-item {
					.image-upload-wrapper {
						flex-direction: column;
						gap: 16px;

						.upload-tips {
							flex: 1;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.aboutus-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			align-items: stretch;

			.header-left {
				justify-content: flex-start;
			}

			.header-actions {
				justify-content: center;
				order: -1;

				.el-button {
					flex: 1;
					max-width: 120px;
				}
			}
		}
	}

	.form-content {
		.aboutus-form {
			:deep(.el-form-item__label) {
				text-align: left;
				float: none;
				display: block;
				width: 100% !important;
				margin-bottom: 8px;
				padding: 0;
			}

			:deep(.el-form-item__content) {
				margin-left: 0 !important;
			}

			.form-section {
				padding: 16px;
			}
		}
	}
}

@media (max-width: 480px) {
	.aboutus-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;

					i {
						font-size: 14px;
					}
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 12px;
					}
				}
			}

			.header-actions {
				.el-button {
					padding: 8px 16px;
					font-size: 13px;

					i {
						font-size: 13px;
					}
				}
			}
		}
	}

	.form-content {
		.aboutus-form {
			.form-section {
				padding: 12px;

				.section-title {
					font-size: 15px;
					margin-bottom: 16px;
				}
			}

			.form-item {
				margin-bottom: 20px;

				.input-wrapper {
					.input-field {
						.field-icon {
							width: 14px;
							height: 14px;
							margin: 0 10px;
						}

						.form-input {
							:deep(.el-input__inner) {
								padding: 10px 0;
								font-size: 14px;
							}
						}
					}

					.field-tip {
						font-size: 11px;
					}
				}

				&.image-item {
					.image-preview {
						.preview-img {
							width: 80px;
							height: 80px;
						}
					}
				}

				&.content-item {
					.content-display {
						padding: 16px;
						font-size: 13px;
					}
				}
			}
		}
	}
}
</style>
